<div class="container">
  <div *ngIf="cartData.data[0].numInCart === 0;" class="text-center my-5">
    <h4>Your Cart Is Empty</h4>
    <button class="btn btn-primary btn-lg mt-3" routerLink="/">GO TO SHOP</button>
  </div>

  <ng-container *ngIf="cartData.data[0].numInCart !== 0">
    <div class="row">
      <div class="col my-4">
        <table class="table">
          <thead class="table-dark">
          <tr class="text-center">
            <th>Image</th>
            <th>Title</th>
            <th>Price</th>
            <th>Quantity</th>
            <th>Subtotal</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let c of cartData.data; let i=index">
            <td class="d-flex align-items-center justify-content-around" >
              <img [src]="imageBaseUrl + c.product.image" alt="{{c.product.name}}" height="60" class="order-1">
              <span class="text-danger mr-md-3" style="cursor: pointer;"><i class="fa fa-trash" (click)="cartService.DeleteProductFromCart(i)"></i></span>
            </td>
            <td><p>{{c.product.name}}</p></td>
            <td>
              <p>{{c.product.price | currency:'INR'}}</p>
            </td>
            <td>
              <form>
                <div class="value-button" id="decrease" (click)="ChangeQuantity(i, false)">
                  <i class="fa fa-minus"></i>
                </div>
                <input type="number" id="number" [value]="c.numInCart" readonly [max]="c.product.quantity" />
                <div class="value-button" id="increase" (click)="ChangeQuantity(i, true)">
                  <i class="fa fa-plus"></i>
                </div>
              </form>
            </td>
            <td>
              <p>{{cartService.CalculateSubTotal(i) | currency:'INR'}}</p>
            </td>
          </tr>
          <tr class="border-0">
            <td style="border: none;"></td>
            <td></td>
            <td></td>
            <td><h3><b>TOTAL</b></h3></td>
            <td><h3><b>{{cartTotal | currency:'INR'}}</b></h3></td>

          </tr>

          </tbody>
        </table>


      </div>

      <div class="col-md-12 d-flex mb-5">
        <div class="d-flex w-100 justify-content-between flex-sm-column flex-md-row">
          <a routerLink="/checkout" class="btn btn-danger btn-sm order-1">Checkout</a>
          <a routerLink="/" class="btn btn-success btn-sm order-0">Continue Shopping</a>
        </div>
      </div>

    </div>
  </ng-container>

</div>
